import React, { useEffect, useState } from 'react'
import requestData from '@api'
import { Link, useStaticQuery, navigate, graphql } from 'gatsby'
import { Button, Grid } from '@components'
import useWindowSize from '@utils/useWindowSize'
import dataLayerGlobal from '@utils/dataLayerGlobal'
import InputMask from 'react-input-mask'
import * as st from '@assets/styl/AboutSection.module.styl'
import whatImg from '@assets/img/carregador.png'
import appImg from '@assets/img/aplicativo.png'
import appImgMobile from '@assets/img/aplicativo.png'
import goalImg from '@assets/img/mercado-automotivo.png'
import customImg from '@assets/img/totem.png'
import whatImgMobile from '@assets/img/carregador-mobile.jpg'
import goalImgMobile from '@assets/img/mercado-automotivo-mobile.jpg'
import customImgMobile from '@assets/img/totem-mobile.jpg'
import cn from 'classnames'
import _ from 'underscore'
import { LazyImageFull, ImageState } from 'react-lazy-images'

export default () => {
  const query = useStaticQuery(graphql`
    query {
      allNumbers {
        nodes {
          title
          number
        }
      }
      allConfigurations {
        nodes {
          whatsapp
        }
      }
      allQuestions {
        nodes {
          title
          content
        }
      }
    }
  `)
  const [numbers, setNumbers] = useState<
    Array<{ title: string; number: string }>
  >(query.allNumbers.nodes)
  useEffect(() => {
    requestData('get', 'numbers?max=9999')
      .then(({ result }) =>
        result
          .sort(({ id: a }, { id: b }) => (a == b ? 0 : b > a ? -1 : 1))
          .forEach(({ title, number }, index) => {
            numbers[index].title = title
            numbers[index].number = number
          })
      )
      .then((_) => setNumbers([...numbers]))
  }, [])
  const vs = useWindowSize()
  const dataLayer = dataLayerGlobal()

  const onIosClick = () => {
    dataLayer.push({
      event: 'GA - Eventos',
      eventCategory: 'Click Download',
      eventLabel: 'IOS',
    })
  }

  const onAndroidClick = () => {
    dataLayer.push({
      event: 'GA - Eventos',
      eventCategory: 'Click Download',
      eventLabel: 'Android',
    })
  }

  const config = query.allConfigurations.nodes[0]
  const questions = query.allQuestions.nodes

  const formatDate = () => {
    const date = new Date()
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }

  const [data, setData] = useState({
    Email: '',
    nome: '',
    Telefone: ''.replace(/\D/g, ''),
    Interesse: '',
    Empresa: '',
    Regiao_de_atuacao: '',
    Politica_de_privacidade: false,
    Communication: false,
    Data_criacao: formatDate(),
    Fluxo_midia: 'Formulário de Contato',
  })
  const [buttonLabel, setButtonLabel] = useState('Enviar')
  const onChange = ({ target: { id, value } }) => {
    setData({ ...data, [id]: value })
  }
  const onChangeCheckbox = ({ target: { id, checked } }) => {
    setData({ ...data, [id]: checked })
  }

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setButtonLabel('Enviando...')

    const sanitizedData = {
      ...data,
      Telefone: data.Telefone.replace(/\D/g, ''),
    }

    fetch('https://admin.wecharge.com.br/api/salesforce', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(sanitizedData),
    }).then((response) => {
      setButtonLabel('Enviar')
      if (response.status === 201) {
        navigate('/sucesso/')
        dataLayer.push({
          event: 'GA - Eventos',
          eventCategory: 'Conversão',
          eventLabel: 'Formulário de contato',
        })
      } else {
        navigate('/404/')
      }
    })
  }

  const onWhatsappClick = () => {
    dataLayer.push({
      event: 'GA - Eventos',
      eventCategory: 'Click WhatsApp',
      eventLabel: 'WhatsApp',
    })
  }

  return (
    <section id="wecharge">
      <Grid>
        <div className={st.app}>
          <LazyImageFull
            src={!vs.width || vs.width < 750 ? appImgMobile : appImg}
          >
            {({ imageState, ref, imageProps: { src } }) => (
              <div ref={ref}>
                <img src={imageState === ImageState.LoadSuccess ? src : ''} />
              </div>
            )}
          </LazyImageFull>
          <div>
            <h4>
              App <b>wecharge</b>
            </h4>
            <h3>Praticidade e controle</h3>
            <p>
              Carregue seu carro <b>elétrico</b> ou <b>híbrido</b> com um toque,
              independente da marca ou modelo de seu veículo.
            </p>
            <ul>
              <li>
                <span className="icon-list-item"></span>
                <span>
                  Encontre pontos de carregamento e saiba seu horário de
                  funcionamento
                </span>
              </li>
              <li>
                <span className="icon-list-item"></span>
                <span>Confira se o eletroposto está ocupado ou disponível</span>
              </li>
              <li>
                <span className="icon-list-item"></span>
                <span>Conheça os plugs disponíveis em cada eletroposto</span>
              </li>
              {/* <li><span className="icon-list-item"></span><span>Faça sua reserva</span></li> */}
              <li>
                <span className="icon-list-item"></span>
                <span>Ative o carregamento e pague diretamente pelo APP</span>
              </li>
              <li>
                <span className="icon-list-item"></span>
                <span>Acompanhe sua recarga remotamente</span>
              </li>
              <li>
                <span className="icon-list-item"></span>
                <span>
                  Consulte seu histórico e <b>muito mais!</b>
                </span>
              </li>
            </ul>
            <p>Baixe agora o App Wecharge</p>
            <div className={st.links}>
              <a
                href="https://apps.apple.com/br/app/wecharge/id1595933153"
                target="_blank"
                className={st.ios}
                onClick={onIosClick}
              ></a>
              <a
                href="https://play.google.com/store/apps/details?id=br.com.voltbras.wecharge&hl=pt"
                target="_blank"
                className={st.android}
                onClick={onAndroidClick}
              ></a>
            </div>
          </div>
        </div>

        <div className={st.what}>
          {(!vs.width || vs.width < 750) && (
            <LazyImageFull src={whatImgMobile}>
              {({ imageState, ref, imageProps: { src } }) => (
                <div ref={ref}>
                  <img src={imageState === ImageState.LoadSuccess ? src : ''} />
                </div>
              )}
            </LazyImageFull>
          )}
          <div>
            <h3>
              Somos uma empresa de mobilidade elétrica e rede de eletropostos
              inteligentes.
            </h3>
            <p>
              Uma rede conectada para facilitar a vida de usuários de carros
              elétricos e híbridos.
            </p>
            <Button to="solucoes" scroll className={st.btn}>
              Conheça nossas soluções
            </Button>
          </div>
          {vs.width >= 750 && (
            <LazyImageFull src={whatImg}>
              {({ imageState, ref, imageProps: { src } }) => (
                <div ref={ref}>
                  <img src={imageState === ImageState.LoadSuccess ? src : ''} />
                </div>
              )}
            </LazyImageFull>
          )}
        </div>

        <div className={st.goal}>
          <div>
            <LazyImageFull
              src={!vs.width || vs.width < 750 ? goalImgMobile : goalImg}
            >
              {({ imageState, ref, imageProps: { src } }) => (
                <div ref={ref}>
                  <img src={imageState === ImageState.LoadSuccess ? src : ''} />
                </div>
              )}
            </LazyImageFull>
          </div>
          <div>
            <h3>
              Nosso objetivo é disseminar a eletrificação no mercado automotivo.
            </h3>
            <p>
              Oferecendo acesso a uma infraestrutura de carregamento de veículos
              elétricos.
            </p>
            <Button to="/pontos-de-recarga/" className={st.btn}>
              Encontre nossos pontos de recarga
            </Button>
          </div>
        </div>

        <div className={st.custom}>
          {(!vs.width || vs.width < 750) && (
            <LazyImageFull src={customImgMobile}>
              {({ imageState, ref, imageProps: { src } }) => (
                <div ref={ref}>
                  <img src={imageState === ImageState.LoadSuccess ? src : ''} />
                </div>
              )}
            </LazyImageFull>
          )}
          <div>
            <h3>Desenvolvemos soluções personalizadas.</h3>
            <p>
              Seguindo os padrões e as tendências dos mercados
              <br /> de automóveis e construção civil.
            </p>
            <Button to="solucoes" scroll className={st.btn}>
              Conheça nossas soluções
            </Button>
          </div>
          {vs.width >= 750 && (
            <LazyImageFull src={customImg}>
              {({ imageState, ref, imageProps: { src } }) => (
                <div ref={ref}>
                  <img src={imageState === ImageState.LoadSuccess ? src : ''} />
                </div>
              )}
            </LazyImageFull>
          )}
        </div>

        <div className={st.numbers}>
          <h3>Números WeCharge</h3>
          <ul>
            <li>
              <div className="icon-users">
                {_.range(1, 8).map((path, key) => (
                  <span key={key} className={`path${path}`}></span>
                ))}
              </div>
              <b>{numbers[4].number}</b>
              {numbers[4].title}
            </li>
            <li>
              <div className="icon-cities">
                {_.range(1, 6).map((path, key) => (
                  <span key={key} className={`path${path}`}></span>
                ))}
              </div>
              <b>{numbers[9].number}</b>
              {numbers[9].title}
            </li>
            <li>
              <div className="icon-stations">
                {_.range(1, 4).map((path, key) => (
                  <span key={key} className={`path${path}`}></span>
                ))}
              </div>
              <b>{numbers[7].number}</b>
              {numbers[7].title}
            </li>
            <li>
              <div className="icon-recharges">
                {_.range(1, 10).map((path, key) => (
                  <span key={key} className={`path${path}`}></span>
                ))}
              </div>
              <b>{numbers[8].number}</b>
              {numbers[8].title}
            </li>
            <li>
              <div className="icon-energy">
                {_.range(1, 16).map((path, key) => (
                  <span key={key} className={`path${path}`}></span>
                ))}
              </div>
              <b>{numbers[10].number}</b>
              {numbers[10].title}
            </li>
          </ul>
        </div>

        <div className={st.formWrapper} id="contato">
          <div>
            <div className={st.text}>
              <h3>Faça parte desta inovação.</h3>
              <p>
                Precisando de carregadores elétricos?
                <br />
                Entre em contato e solicite mais informações.
              </p>
              {/* <Button
                to={`https://whatsa.me/554899831224/?t=Ol%C3%A1!%20Vim%20pelo%20site%20da%20WeCharge%20e%20gostaria%20de%20saber%20mais%20informa%C3%A7%C3%B5es`}
                external
                color="green"
                className={st.wppBtn}
                onClick={onWhatsappClick}
              >
                <span className="icon-whatsapp"></span>
                Chamar no WhatsApp
              </Button> */}
            </div>
            <form onSubmit={onSubmit}>
              <div className={st.formGroup}>
                <label htmlFor="nome">Nome</label>
                <input
                  type="text"
                  id="nome"
                  required
                  value={data.nome}
                  onChange={onChange}
                />
              </div>
              <div className={st.formGroup}>
                <label htmlFor="Email">E-mail</label>
                <input
                  type="email"
                  id="Email"
                  required
                  value={data.Email}
                  onChange={onChange}
                />
              </div>
              {/* <div className={st.formGroup}>
                <label htmlFor="Finalidade_de_contato">
                  Finalidade do contato
                </label>
                <select
                  id="Finalidade_de_contato"
                  required
                  value={data.Finalidade_de_contato}
                  onChange={onChange}
                >
                  <option hidden disabled value="">
                    Finalidade do contato
                  </option>
                  <option>Carregador para o meu estabelecimento</option>
                  <option>Carregador para minha garagem</option>
                  <option>Carregador para o meu condomínio</option>
                  <option>Carregador para minha frota</option>
                  <option>Outra</option>
                </select>
              </div> */}
              <div className={st.formGroup}>
                <label htmlFor="Telefone">Telefone</label>
                <InputMask
                  mask={
                    data.Telefone.length > 14
                      ? '(99) 99999-9999'
                      : '(99) 9999-99999'
                  }
                  maskChar={null}
                  type="tel"
                  id="Telefone"
                  required
                  pattern=".{14,15}"
                  value={data.Telefone}
                  onChange={onChange}
                />
              </div>
              <div className={st.formGroup}>
                <label htmlFor="Interesse">Qual é o seu interesse?</label>
                <select
                  id="Interesse"
                  required
                  value={data.Interesse}
                  onChange={onChange}
                >
                  <option hidden disabled value="">
                    Escolha uma opção
                  </option>
                  <option>Ser um revendedor</option>
                  <option>Ser um instalador</option>
                  <option>Ter um eletroposto no seu negócio</option>
                  <option>Carregador para minha frota</option>
                  <option>Investir em eletropostos</option>
                </select>
              </div>
              <div className={st.formGroup}>
                <label htmlFor="Empresa">Qual é a sua empresa?</label>
                <input
                  type="text"
                  id="Empresa"
                  required
                  value={data.Empresa}
                  onChange={onChange}
                />
              </div>
              <div className={st.formGroup}>
                <label htmlFor="Regiao_de_atuacao">
                  Qual é a sua região de atuação?
                </label>
                <input
                  type="text"
                  id="Regiao_de_atuacao"
                  required
                  value={data.Regiao_de_atuacao}
                  onChange={onChange}
                />
              </div>
              <div className={cn(st.formGroup, st.wide, st.checkboxWrapper)}>
                <input
                  type="checkbox"
                  id="Politica_de_privacidade"
                  required
                  checked={data.Politica_de_privacidade}
                  onChange={onChangeCheckbox}
                />
                <label htmlFor="Politica_de_privacidade">
                  Ao me cadastrar estou de acordo com os{' '}
                  <Link to="/termos-de-uso/" target="_blank">
                    termos de uso
                  </Link>{' '}
                  e{' '}
                  <Link to="/politica-de-privacidade/" target="_blank">
                    política de privacidade
                  </Link>
                  .
                </label>
              </div>
              <div className={cn(st.formGroup, st.wide, st.checkboxWrapper2)}>
                <input
                  type="checkbox"
                  id="Communication"
                  required
                  checked={data.Communication}
                  onChange={onChangeCheckbox}
                />
                <label htmlFor="Communication">
                  Autorizo a WeCharge, empresa pertencente ao Grupo Dimas Auto,
                  a compartilhar meus dados com as demais empresas do Grupo para
                  envio de campanhas de marketing e informações.
                </label>
              </div>
              <div className={st.btnWrapper}>
                <Button className={st.btn}>{buttonLabel}</Button>
              </div>
            </form>
          </div>
        </div>
      </Grid>
    </section>
  )
}
